import styled from 'styled-components';
import { Checkbox } from 'antd';
// Checkbox with suffix
export const CheckboxWrapper = styled(Checkbox)`
  width: 100%;
  > span:last-child {
    flex: 1;
  }
`;
